const BLOCKED_NAVIGATION_SCHEMES: Record<string, true> = {
  javascript: true,
  vbscript: true,
  livescript: true,
  data: true,
  file: true,
  blob: true,
}

const MAX_NAVIGATION_TARGET_LENGTH = 500

export function sanitizeNavigationTarget(target: string | null | undefined): string | null {
  const trimmed = target?.trim()
  if (!trimmed) return null
  if (trimmed.length > MAX_NAVIGATION_TARGET_LENGTH) return null
  if (hasAsciiControlCharacter(trimmed)) return null

  let parsed: URL
  try {
    parsed = new URL(trimmed)
  } catch {
    return null
  }

  const scheme = parsed.protocol.slice(0, -1).toLowerCase()
  if (!scheme || BLOCKED_NAVIGATION_SCHEMES[scheme]) return null
  return trimmed
}

function hasAsciiControlCharacter(value: string): boolean {
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index)
    if (code <= 31 || code === 127) return true
  }
  return false
}

export function openNavigationTarget(target: string | null | undefined): boolean {
  const safeTarget = sanitizeNavigationTarget(target)
  if (!safeTarget) return false
  window.open(safeTarget, '_blank', 'noopener')
  return true
}
